export const AMZ_ADS_MAX_CHARGE_MONTHLY_FACTOR = 30.4;
export const AMZ_ADS_FLEX_CHARGE_DAILY_FACTOR = 2;